// @flow
import store from 'app/common/redux/store/singleton';
import { OpenLoginModal } from 'app/common/redux/actions/login';

// Use this to intercept the initiation of a flow that requires full authentication
// and instead show a login modal.
const authAction = (fn: *) => {
  const state = (store.instance && store.instance.getState()) || {
    viewer: {},
  };
  return !state.viewer.isAuth || state.viewer.isLimitedLogin
    ? (e: ?*) => store.instance.dispatch(OpenLoginModal)
    : fn;
};

export default authAction;
